'use strict';
const template = require('./text-modal.html');

module.exports = [
  '$modal',
  HelpService];

// TODO(i18n): Translate documentation and figure out to manage this data. We should probably make this an iframe linking the content from an external knowledge base?
function HelpService($modal) {

  this.showTextModal = showTextModal;

  function showTextModal(title, content) {
    return $modal.show({
      template: template,
      controller: 'HelpController',
      animation: 'slide-in-up',
      locals: {
        title: title,
        content: content,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/help/HelpService.js